import { storageKeys, type ApiErrorResponse } from '@feltos/shared'

export interface RequestOptions extends Omit<RequestInit, 'body'> {
  json?: unknown
  fallback?: string
}

function playerAuthHeaders(): Record<string, string> {
  if (typeof window === 'undefined') return {}
  const token = window.localStorage.getItem(storageKeys.playerToken)
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export class RequestError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message)
    this.name = 'RequestError'
  }
}

export async function request<T>(
  url: string,
  options: RequestOptions = {},
): Promise<T> {
  const { json, fallback = '请求失败', headers, ...init } = options
  let response: Response
  try {
    response = await fetch(url, {
      ...init,
      headers: {
        ...playerAuthHeaders(),
        ...(json === undefined ? {} : { 'Content-Type': 'application/json' }),
        ...headers,
      },
      body: json === undefined ? undefined : JSON.stringify(json),
    })
  } catch {
    throw new RequestError(fallback, 0)
  }

  if (response.status === 204) return undefined as T

  let payload: T & ApiErrorResponse
  try {
    payload = (await response.json()) as T & ApiErrorResponse
  } catch {
    throw new RequestError(fallback, response.status)
  }
  if (!response.ok)
    throw new RequestError(payload.error ?? fallback, response.status)
  return payload
}

export function fetcher<T>(url: string): Promise<T> {
  return request<T>(url)
}
